import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell, { Field } from "./AuthShell";
import { useAuth, homeFor } from "../context/AuthContext";
import { errMsg } from "../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={homeFor(user)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(form.email, form.password);
      navigate(homeFor(data.user));
    } catch (err) {
      setError(errMsg(err));
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Log in to see what your customers are saying."
      footer={<>New to Bonus Thought? <Link to="/register" className="font-semibold text-[#2F5D4A] hover:underline" data-testid="login-to-register-link">Create an account</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="business-login-form">
        <Field label="Email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" autoComplete="email" />
        <Field label="Password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" autoComplete="current-password" />
        <div className="-mt-2 text-right">
          <Link to="/forgot-password" className="text-sm font-semibold text-[#2F5D4A] hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
        </div>
        {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-3 py-2" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center !py-3" data-testid="login-submit-button">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Log in"}
        </button>
      </form>
    </AuthShell>
  );
}
